import appService from '../../services/appService'
import axiosInstance from '../../plugin/axios'

export const posOrder = {
  namespaced: true,
  state: {
    lists: [],
    page: {},
    pagination: [],
    show: {},
    orderItems: {},
    orderBranch: {},
    orderUser: {},
    temp: {
      temp_id: null,
      isEditing: false
    }
  },
  getters: {
    lists: function (state) {
      return state.lists
    },

    pagination: function (state) {
      return state.pagination
    },
    page: function (state) {
      return state.page
    },
    show: function (state) {
      return state.show
    },
    orderItems: function (state) {
      return state.orderItems
    },
    orderBranch: function (state) {
      return state.orderBranch
    },
    orderUser: function (state) {
      return state.orderUser
    },
    temp: function (state) {
      return state.temp
    }
  },
  actions: {
    lists: function (context, payload) {
      return new Promise((resolve, reject) => {
        let url = 'admin/pos-order'
        if (payload) {
          url = url + appService.requestHandler(payload)
        }
        axiosInstance
          .get(url)
          .then((res) => {
            if (typeof payload.vuex === 'undefined' || payload.vuex === true) {
              context.commit('lists', res.data.data)
              context.commit('page', res.data.meta)
              context.commit('pagination', res.data)
            }

            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    save: function (context, payload) {
      return new Promise((resolve, reject) => {
        axiosInstance
          .post('admin/pos', payload)
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    show: function (context, payload) {
      return new Promise((resolve, reject) => {
        axiosInstance
          .get(`admin/pos-order/show/${payload}`)
          .then((res) => {
            context.commit('show', res.data.data)
            context.commit('orderItems', res.data.data.order_items)
            context.commit('orderBranch', res.data.data.branch)
            context.commit('orderUser', res.data.data.user)
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    destroy: function (context, payload) {
      return new Promise((resolve, reject) => {
        axiosInstance
          .delete(`admin/pos-order/${payload.id}`)
          .then((res) => {
            context.dispatch('lists', payload.search).then().catch()
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    changeStatus: function (context, payload) {
      return new Promise((resolve, reject) => {
        axiosInstance
          .post(`admin/pos-order/change-status/${payload.id}`, payload)
          .then((res) => {
            context.commit('show', res.data.data)
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    changePaymentStatus: function (context, payload) {
      return new Promise((resolve, reject) => {
        axiosInstance
          .post(`admin/pos-order/change-payment-status/${payload.id}`, payload)
          .then((res) => {
            context.commit('show', res.data.data)
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    reset: function (context) {
      context.commit('reset')
    },
    export: function (context, payload) {
      return new Promise((resolve, reject) => {
        let url = 'admin/pos-order/export'
        if (payload) {
          url = url + appService.requestHandler(payload)
        }
        axiosInstance
          .get(url, { responseType: 'blob' })
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  },
  mutations: {
    lists: function (state, payload) {
      state.lists = payload
    },
    pagination: function (state, payload) {
      state.pagination = payload
    },
    page: function (state, payload) {
      if (typeof payload !== 'undefined' && payload !== null) {
        state.page = {
          from: payload.from,
          to: payload.to,
          total: payload.total
        }
      }
    },
    show: function (state, payload) {
      state.show = payload
    },
    orderItems: function (state, payload) {
      state.orderItems = payload
    },
    orderBranch: function (state, payload) {
      state.orderBranch = payload
    },
    orderUser: function (state, payload) {
      state.orderUser = payload
    },
    reset: function (state) {
      state.temp.temp_id = null
      state.temp.isEditing = false
    }
  }
}
